import Immutable from 'immutable';
import { Link, LinkList, RawLink } from 'records/Link';
import { PageId } from 'records/Page';
import GQLRequest from 'utils/GQLRequest';

export interface GetLinksResponse {
  links: RawLink[];
  cursor: string;
}

export const getLinks = async (pageid: PageId): Promise<LinkList> => {
  const { getLinks } = await new GQLRequest()
    .query(
      `
      query GetLinks($pageid: String!) {
        getLinks(pageid: $pageid) {
          links {
            linkid
            sourcepageid
            originalmarkupboundingbox
            destinationviewport
            destinationpageid
            destinationsheetnumber
            destinationurl
          }
        }
      }
      `
    )
    .variables({ pageid })
    .json<{ getLinks: GetLinksResponse }>();

  return Immutable.List(getLinks.links.map(Link.deserialize));
};
